export default __webpack_public_path__ + "static/media/tech-bg.9840a6b3.png";